export class ScrollObserver {
    constructor() {

        const btt = document.querySelector('.back-to-top-container');

        if (btt) {
            this.scrollY = window.scrollY;
            const scrollUpTop = btt.getBoundingClientRect().top + window.scrollY;
            if (scrollUpTop > window.innerHeight) {
                btt.classList.add('show-back-to-top');
            }

            window.addEventListener('scroll', this.scrollHandler.bind(this));

            this.scrollHandler();
        }

        const complianceWarning = document.querySelector('.footer .warning.compliance');

        if (complianceWarning) {
            if (document.body.classList.contains('calculus-eis')) {
                const observer = new IntersectionObserver(entries => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            complianceWarning.classList.remove('show');
                        } else {
                            complianceWarning.classList.add('show');
                        }
                    });
                }, {
                    rootMargin: '-240px 0px 0px 0px'
                });
    
                observer.observe(document.querySelector('.main .section.warning'));
            }
        }

    }

    scrollHandler() {
        const y = window.scrollY;

        if (y > 0) {
            if (!this.scrolled) {
                document.body.classList.add('scrolled');
                this.scrolled = true;
            }
        } else {
            if (this.scrolled) {
                this.scrolled = false;
                document.body.classList.remove('scrolled');
            }
        }

        this.scrollY = y;
    }
}